// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 2421 ? "4286a96f" : chunkId) + "." + {"2421":"c51ab5dda2540055","6707":"7ca113e64efbc478"}[chunkId] + ".js";
};